export default __webpack_public_path__ + "static/frame-4-f727174ed7c9aaba085af7fca93542f2.png";